import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { addPointerEvent } from '../events/add-pointer-event.mjs';
import { pipe } from '../utils/pipe.mjs';
import { isDragActive } from './drag/utils/lock.mjs';
import { Feature } from '../motion/features/Feature.mjs';
import { sync } from '../frameloop/index.mjs';
function addHoverEvent(node, isActive) {
  var eventName = "pointer" + (isActive ? "enter" : "leave");
  var callbackName = "onHover" + (isActive ? "Start" : "End");
  var handleEvent = function handleEvent(event, info) {
    if (event.type === "touch" || isDragActive()) return;
    var props = node.getProps();
    if (node.animationState && props.whileHover) {
      node.animationState.setActive("whileHover", isActive);
    }
    if (props[callbackName]) {
      sync.update(function () {
        return props[callbackName](event, info);
      });
    }
  };
  return addPointerEvent(node.current, eventName, handleEvent, {
    passive: !node.getProps()[callbackName]
  });
}
var HoverGesture = /*#__PURE__*/function (_Feature) {
  _inherits(HoverGesture, _Feature);
  var _super = _createSuper(HoverGesture);
  function HoverGesture() {
    _classCallCheck(this, HoverGesture);
    return _super.apply(this, arguments);
  }
  _createClass(HoverGesture, [{
    key: "mount",
    value: function mount() {
      this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
  return HoverGesture;
}(Feature);
export { HoverGesture };